export default class Spouse {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  officeId;

  /**
   * @type {string}
   */
  stateId;

  /**
   * @type {string}
   */
  ssn;

  /**
   * @type {string}
   */
  firstName;

  /**
   * @type {string}
   */
  lastName;

  /**
   * @type {string}
   */
  email;

  /**
   * @type {string}
   */
  phone;

  /**
   * @type {string}
   */
  dateAdded;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.stateId != null) {
        this.stateId = opts.stateId;
      }
      if (opts.ssn != null) {
        this.ssn = opts.ssn;
      }
      if (opts.firstName != null) {
        this.firstName = opts.firstName;
      }
      if (opts.lastName != null) {
        this.lastName = opts.lastName;
      }
      if (opts.email != null) {
        this.email = opts.email;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
    }
  }
}
